module.exports = __webpack_public_path__ + "static/media/video.cd25b7d7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/overlay-icons/video.svg
// module id = 847
// module chunks = 0